// extracted by mini-css-extract-plugin
module.exports = {"vk_auth":"SignIn_vk_auth__l8Bw-"};